/* eslint-disable no-nested-ternary */
import React, {
  useContext,
  useCallback,
  useState,
  useRef,
  useEffect,
  useMemo,
} from 'react';
import classNames from 'classnames';
import loadable from '@loadable/component';
import LayoutContainer from '../../LayoutContainer';
import { COOKIES } from '../../../constants';
import { Context } from '../../../context/AppContext';
import useScrollPosition from '../../../hooks/useScrollPosition';
import HeaderBannerChristmas from '../../../assets/header/headerBannerChristmas.png';
import './styles.css';

const { ALERT_BANNER } = COOKIES;

const NotificationAlert = loadable(() => import('../../NotificationAlert'), {
  ssr: false,
});

const Wrapper = ({
  slideIn,
  className,
  style,
  christmas,
  children,
  headerBottom,
}) => {
  const {
    media: { device },
    cookie: { getCookie },
    notificationBar: { notificationShow },
  } = useContext(Context);
  const [bannerActive, setBannerActive] = useState(!getCookie(ALERT_BANNER));
  const [showHeader, setShowHeader] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef();
  const { current = {} } = headerRef;
  const callback = useCallback(() => {
    setShowHeader((slideIn || bannerActive) && window.scrollY > 44);
  }, [slideIn, bannerActive]);

  useScrollPosition(null, callback);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (bannerActive && bannerActive !== 'false') {
        setHeaderHeight(current.offsetHeight);
      } else {
        setHeaderHeight(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [bannerActive, current]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setBannerActive(
        !getCookie(ALERT_BANNER) || getCookie(ALERT_BANNER) !== 'false'
      );
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const onNotificationChange = useCallback(
    isBannerActive => {
      setBannerActive(isBannerActive);
      if (isBannerActive || bannerActive !== 'false') {
        setHeaderHeight(current.offsetHeight);
      } else {
        setHeaderHeight(false);
      }
    },
    [current]
  );

  const backgroundOverlay = useMemo(() => {
    if (christmas) return HeaderBannerChristmas;
    return null;
  }, [christmas]);

  return (
    <div
      style={{
        height: headerHeight,
      }}
      className={classNames('Header__wrapper', {
        [`Header__wrapper--${device}`]: device,
        'Header__wrapper--notificationHidden': !notificationShow,
        [className]: className,
        'Header--backgroundOverlay': backgroundOverlay,
        'Header__wrapper--notificationAlertShow': bannerActive,
      })}
    >
      <div
        ref={headerRef}
        className={classNames('Header__root', {
          'Header__root--slideIn': slideIn,
          'Header__root--show': showHeader,
          'Header__root--fixed': !notificationShow || !bannerActive,
          'Header__root--bannerActive':
            notificationShow && bannerActive && bannerActive !== 'false',
        })}
      >
        {!showHeader && bannerActive && (
          <NotificationAlert onChange={onNotificationChange} />
        )}
        <LayoutContainer
          className="Header__container"
          type="fullWidth"
          style={{
            ...(style || {}),
            ...{
              ...(backgroundOverlay
                ? {
                    backgroundImage: `url(${backgroundOverlay})`,
                  }
                : {}),
            },
          }}
        >
          {children}
        </LayoutContainer>
        {!!headerBottom && (
          <LayoutContainer className="Header__bottom" type="fullWidth">
            {headerBottom}
          </LayoutContainer>
        )}
      </div>
    </div>
  );
};

export default Wrapper;
